<template>
	<div class="bind-finish">
		<el-form ref="form" :model="form" :rules="rules" label-width="120px">
			<el-form-item label="access_token：" prop="accessToken">
				<el-input placeholder="请输入access_token" v-model="form.accessToken" clearable></el-input>
			</el-form-item>
		</el-form>
		<p class="tips">复制微博帐号“开发者管理”-“服务器配置”生成的access_token填入</p>
		<div class="footer">
			<el-button size="mini" @click="onPre">上一步</el-button>
			<el-button type="primary" size="mini" @click="onFinish" :loading="loading">{{loading ? '提交中' : '完 成'}}</el-button>
		</div>
	</div>
</template>

<script>
	export default {
		props:{
			source:{
				default:''
			},
			copySource:{
				default:''
			}
		},
		watch:{
			source:{
				handler(value){
					if(value){
						this.form.accessToken = value.accessToken || '';
					}
				},
				deep:true,
				immediate:true
			}
		},
		data(){
			return {
				form:{
					accessToken:'',
					//forwardUrl:'',
					//messageType:'',
					//weiboName:'',
					weiboid:'',
					appKey:''
				},
				rules:{
					accessToken:[
						{ required: true, message: '请输入access_token', trigger: 'blur' },
						{ min: 10, max: 64, message: '长度在 10 到 64 个字符', trigger: 'blur' },
					],
				},
				loading:false
			}
		},
		methods:{
			onPre(){
				this.$emit('onPre')
			},
			onFinish(){
				this.$refs.form.validate((valid) => {
					if(valid){
						this.loading = true;
						this.form.weiboid = this.source?.weiboId || this.copySource?.weiboid;
						this.form.appKey = this.copySource?.appKey;
						this.$api.updateWeiboConfigsForSystem(this.form).then(res => {
							this.loading = false;
							if(res.errcode != 0) return;
							this.$notify.success('绑定成功');
							this.$emit('onFinish');
							this.$emit('getList')
						}).catch(err => {
							this.loading = false
						})
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.bind-finish {
		.tips {
			font-size: 12px;
			color: #F29522;
			padding-left: 120px;
			margin: 15px 0;
		}
		.footer {
			float: right;
		}
	}
</style>